const componentsDataTableEn = {
  accessibleCategories: {
    large: 'Large',
    medium: 'Medium',
    small: 'Small'
  },
  attendanceActivity: {
    activityType: 'Activity',
    actor: 'Actor',
    detail: 'Detail',
    occurredAt: 'Occurred at',
    origin: 'Origin',
    target: 'Target employee'
  },
  attendanceClosingDaily: {
    breakMinutes: 'Break (min)',
    clockIn: 'Clock-in',
    clockOut: 'Clock-out',
    employeeName: 'Employee',
    needsAttention: 'Attention',
    progressStatus: 'Status',
    workDate: 'Date',
    workStatus: 'Attendance status',
    workplace: 'Workplace / store'
  },
  attendanceClosingMonthly: {
    closureStatus: 'Close status',
    department: 'Department',
    employeeName: 'Employee',
    employeeNumber: 'Employee no.',
    missingPunchCount: 'Open missing punches',
    needsAttention: 'Attention',
    overtimeHours: 'Overtime (h)',
    paidLeaveDays: 'Paid leave (days)',
    progressStatus: 'Status',
    scheduledHours: 'Scheduled (h)',
    targetMonth: 'Target month',
    workedHours: 'Worked (h)'
  },
  attendanceClosingPlace: {
    employeeCount: 'Employees',
    missingPunchOpen: 'Open missing punches',
    needsAttention: 'Attention',
    pendingApprovals: 'Pending approvals',
    progressStatus: 'Status',
    readiness: 'Close readiness',
    totalWorkedHours: 'Total worked (h)',
    workplaceCode: 'Code',
    workplaceName: 'Workplace / store'
  },
  businessPartner: {
    businessPartnerActivePeriod: 'BP Active Period',
    businessPartnerAddress: 'Address',
    businessPartnerName: 'Business Partner Name',
    businessPartnerRegistrationDate: 'BP Registration Date',
    businessPartnerRole: 'BP Role',
    businessPartnerStatus: 'BP Status',
    businessPartnerTerminationDate: 'BP Termination Date',
    businessPartnerType: 'BP Type'
  },
  categoryPermissions: {
    intendedUse: 'Intended use',
    permissionName: 'Category permission name'
  },
  certification: {
    certificationCode: 'Certification Code',
    certificationName: 'Certification Name',
    certificationsHolders: 'Certifications Holders',
    complianceRiskLevel: 'Compliance risk level',
    effectiveFrom: 'Effective From',
    effectiveTo: 'Effective To',
    industryCategory: 'Industry Category',
    issuingOrganization: 'Issuing Organization'
  },
  certificationHolder: {
    certificationHolder: 'Certification Holder',
    certificationNumber: 'Certification Number',
    lastRenewalDate: 'Last Renewal Date',
    renewalDeadline: 'Renewal Deadline',
    validTo: 'Valid To'
  },
  deviceCatalog: {
    activatedAt: 'Activated At',
    archivedAt: 'Archived At',
    categoryId: 'Category ID',
    status: 'Status',
    updatedAt: 'Updated At'
  },
  deviceGroups: {
    intendedUse: 'Intended use',
    name: 'Group name',
    targetDeviceCount: 'Total devices'
  },
  educationsAndQualifications: {
    certificationName: 'Certification Name',
    certificationNumber: 'Certification Number',
    lastRenewalDate: 'Last Renewal Date',
    renewalDeadline: 'Renewal Deadline',
    validTo: 'Valid To'
  },
  externalHrSaas: {
    lastSyncedAt: 'Last synced date',
    syncResult: 'Sync result',
    syncType: 'Sync Type'
  },
  externalItSaas: {
    appIntegration: 'Connected Service',
    lastSyncedAt: 'Last synced date',
    syncResult: 'Sync result',
    syncType: 'Sync Type'
  },
  govDocumentType: {
    applicationType: 'Application Type',
    documentName: 'Document Name'
  },
  handlingCertification: {
    certificationsHolders: 'Certifications Holders',
    handlingCode: 'Handling Code',
    handlingName: 'Handling Name',
    issuingOrganization: 'Issuing Organization'
  },
  healthInsuranceAssociations: {
    associationName: 'Health insurance society name',
    associationType: 'Health insurance society type'
  },
  hrPrimary: 'Primary',
  itOperationCore: {
    progress: 'progress',
    requestedFor: 'requested for'
  },
  license: {
    assignedTotal: 'Assigned/Total',
    assignedUser: 'Device assignment',
    device: 'License assigned device',
    enabledTotal: 'Enabled/Total',
    expirationDate: 'License expiration date',
    name: 'License',
    notes: 'Notes',
    ownerOrganization: 'License owner organization unit',
    placement: 'Device placement',
    productVersion: 'Product version',
    renewalDate: 'Renewal date',
    responsiblePerson: 'Responsible person',
    vendorName: 'Vendor name'
  },
  licenseService: {
    externalId: 'External ID'
  },
  operationArchives: {
    anchorDate: 'Anchor Date',
    archived: 'Archived',
    completed: 'Completed',
    createdAt: 'Started At',
    finishedAt: 'Finished At',
    operator: 'Operator',
    packageName: 'Operation Package',
    patternName: 'Pattern',
    status: 'Status',
    targetResource: 'Target'
  },
  operationCoreDashboard: {
    assignee: 'Assignee',
    dueDate: 'Due date',
    eventTitle: 'Business event',
    needsAttention: 'Attention',
    progress: 'Progress',
    rowKind: 'Row type',
    status: 'Status',
    stepName: 'Step'
  },
  organization: {
    hierarchyLevel: 'Hierarchy Level',
    manager: 'Manager',
    orderInHierarchy: 'Order in Hierarchy',
    parentName: 'Parent Name',
    path: 'Path',
    size: 'Size'
  },
  organizationName: 'Organization',
  organizationPlan: {
    effectiveDate: 'Effective date'
  },
  payrollDepartment: {
    deductionTotal: 'Total deductions',
    departmentCode: 'Department code',
    departmentName: 'Department',
    employeeCount: 'Employees',
    grossPayTotal: 'Gross total',
    needsAttention: 'Attention',
    netPayTotal: 'Net total',
    pendingCount: 'Pending',
    progressStatus: 'Status'
  },
  payrollEmployee: {
    calculationStatus: 'Calc. status',
    deductionTotal: 'Total deductions',
    department: 'Department',
    employeeName: 'Employee',
    employeeNumber: 'Employee no.',
    grossPay: 'Gross pay',
    needsAttention: 'Attention',
    netPay: 'Net pay',
    targetMonth: 'Target month'
  },
  payrollItem: {
    applicableCount: 'People',
    averageAmount: 'Average',
    itemCategory: 'Category',
    itemCode: 'Code',
    itemName: 'Item name',
    needsAttention: 'Attention',
    progressStatus: 'Status',
    targetMonth: 'Target month',
    totalAmount: 'Total'
  },
  peopleActivity: {
    activityType: 'Activity',
    actor: 'Operated By',
    member: 'Member',
    occurredAt: 'Date & Time',
    origin: 'Operation'
  },
  peopleCertification: {
    baseCertification: 'Base Certification',
    handlingCertification: 'Handling Certification',
    organization: 'Organization',
    person: 'Person',
    place: 'Place',
    specialtyCertification: 'Specialty Certification'
  },
  peopleGroups: {
    individuallyExcluded: 'Individually excluded',
    individuallyIncluded: 'Individually included',
    label: {
      organizationUnits: {
        allSubordinates: "{{organizationName}}'s all subordinates",
        allSubordinatesWithoutMe: "{{organizationName}}'s all subordinates（Excluding Organization {{organizationName}}）"
      }
    },
    membershipBoardMember: 'Membership Board member',
    membershipCollaborator: 'Membership Collaborator',
    membershipContractor: 'Membership Contractor',
    membershipEmployee: 'Membership Employee',
    name: 'Name',
    organizationUnits: 'Membership Organization',
    referencedRoles: 'Referenced roles',
    totalPeople: 'Total people'
  },
  placeSocialInsurances: {
    address: 'Address',
    businessEstablishment: 'Business Establishment',
    representative: 'Representative'
  },
  productPermissionForces: {
    code: '',
    // 空ヘッダー
    scopes: 'Product'
  },
  productPermissions: {
    businessCentral: 'Business Central',
    gaForce: 'GA Force',
    hrForce: 'HR Force',
    itForce: 'IT Force',
    liForce: 'LI Force',
    marketplace: 'Marketplace',
    memberPortal: 'Member Portal',
    operationEvent: 'Business Operation Events',
    productPermissionName: 'Product permission name',
    referencedRoles: 'Referenced roles',
    settings: 'Settings',
    totalAccessibleProducts: 'Total accessible products'
  },
  roles: {
    categoryFieldAccessPermissions: 'Category permission',
    peopleGroups: 'People group',
    productPermissions: 'Product permission',
    roleName: 'Role name',
    totalPeople: 'Total people'
  },
  shadowIt: {
    app: 'App',
    category: 'Category',
    count7DaysDetected: '7 Days Access Count',
    count30DaysDetected: '30 Days Access Count',
    countUniqueUser: 'Unique User Count',
    detectionTool: 'Detection Tool',
    software: 'Software',
    url: 'Accessed URL',
    usedLoginId: 'Used Login ID',
    user: 'Recently Accessed Person',
    visitedAt: 'Detected At',
    websiteUrl: 'Link'
  },
  softwareActivity: {
    activityType: 'Activity',
    actor: 'Operated By',
    occurredAt: 'Date & Time',
    origin: 'Operation',
    software: 'Software',
    target: 'Target'
  },
  specialtyCertification: {
    certificationsHolders: 'Certifications Holders',
    issuingOrganization: 'Issuing Organization',
    specialtyCategoryName: 'Specialty Category Name',
    specialtyCertificationCode: 'Specialty Certification Code',
    specialtyLevelName: 'Specialty Level Name',
    specialtyName: 'Specialty Certification Name'
  },
  storageFiles: {
    settings: {
      table: {
        columns: {
          lastSyncedAt: 'Last Synced At',
          software: 'Software',
          syncEnabled: 'Sync Configuration'
        }
      }
    }
  },
  supplierLedger: {
    avlEarliestNextReviewDate: 'AVL Next Review',
    avlStatus: 'AVL Certification',
    bpStatus: 'BP Status',
    category: 'Supplier Category',
    procurementCategory: 'Procurement Category',
    segment: 'Segment',
    supplierName: 'Supplier',
    supplierStatus: 'SUP Status',
    supplyType: 'Supply Type',
    tier: 'Tier',
    updatedAt: 'Updated'
  },
  vendorMarketplace: {
    acceptedAt: 'Agreement date',
    canceledAt: 'Cancellation date',
    customer: 'Customer',
    deliveryDate: 'Delivery date',
    orderNumber: 'Order No.',
    orderedByPerson: 'Ordered by',
    sentAt: 'Request date',
    title: 'Title',
    total: 'Total'
  }
};
export default componentsDataTableEn;